import { Chip } from '@thoughtspot/radiant-react/widgets/chip';
import { ChipInputProps } from '@thoughtspot/radiant-react/widgets/chip/chip-input';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import _ from 'lodash';
import React, { useRef } from 'react';
import { Key } from 'w3c-keys';
import styles from './user-selection-input-text-box.module.scss';

export interface UserSelectionInputTextBoxProps {
    onEnter: () => void;
    onTab?: () => void;
    onSpace?: () => void;
    onBackspace?: () => void;
    userChips: ChipInputProps[];
    searchInput: string;
    onInputChange: (searchInput: string) => void;
    removeUser: (user: string) => void;
    validateEmail: (email: string) => void;
    chipBodyClicked: (userId: string) => void;
}

export const UserSelectionInputTextBox: React.FC<UserSelectionInputTextBoxProps> = ({
    onEnter,
    onTab,
    onSpace,
    onBackspace,
    userChips,
    searchInput,
    onInputChange,
    removeUser,
    validateEmail,
    chipBodyClicked,
}) => {
    const userChipsAndInputRef = useRef();
    const userInputRef = useRef<HTMLInputElement>(null);
    const focusUsersInput = () => userInputRef?.current?.focus();

    const onBlur = () => {
        if (!_.isEmpty(searchInput)) {
            validateEmail(searchInput);
        }
    };

    return (
        <div
            data-testid="token-bar-container"
            spellCheck="false"
            aria-hidden="true"
            className={styles.addUserInputBox}
            onClick={focusUsersInput}
            onKeyDown={(event: React.KeyboardEvent<HTMLElement>) => {
                if (event.key === Key.Enter) {
                    focusUsersInput();
                }
            }}
            key="token-bar"
        >
            <div className={styles.userChipAndInput} ref={userChipsAndInputRef}>
                {userChips.map(user => {
                    return (
                        <Chip.Input
                            key={user.id}
                            {...user}
                            data-testid={user.id}
                            className={styles.userChips}
                            onIconClick={() => removeUser(user.id)}
                            onClick={() => chipBodyClicked(user?.id)}
                        />
                    );
                })}
                <Input.Text
                    onEnter={onEnter}
                    onTab={onTab}
                    onSpace={onSpace}
                    onKeyDown={event => {
                        if (event.key === Key.Backspace && !searchInput) {
                            // Only trigger when input is empty
                            event.preventDefault();
                            onBackspace?.();
                        }
                    }}
                    data-testid="user-input"
                    value={searchInput}
                    ariaLabel="User input component"
                    inputClassName={styles.userInput}
                    className={styles.userInput}
                    inputRef={userInputRef}
                    onChange={(_event, value: string) => onInputChange(value)}
                    onBlur={onBlur}
                />
            </div>
        </div>
    );
};
